<app-base-template (modal)="openModal(content)" (index)="createIndex()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)" [showIndex]="showIndex"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add FAQ</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categorys" [value]="category.id">{{category.mastercategory}}</option>
      </select>
    </div>
    <div *ngFor="let faq of faqDetails; let i = index;">
      <span class="red font-13">Question: {{i + 1}}</span><br/>
        <div class="form-group">
        <textarea class="form-control radius-0 font-13" [(ngModel)]="faq.question"
                  placeholder="FAQ Question" [id] = "'Q'+i"> </textarea>
        </div>
      <span class="red font-13">Answer: {{i + 1}}</span><br/>
        <ck-editor [(ngModel)]="faq.answer" skin="moono-lisa" language="en" [fullPage]="true" [id] = "'A'+i"></ck-editor>
    </div> <br/>
    <button (click)="addFaq()">Add more</button>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Update FAQ</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categorys" [value]="category.id">{{category.mastercategory}}</option>
      </select>
    </div>
      <span class="red font-13">Question: </span><br/>
      <div class="form-group">
        <textarea class="form-control radius-0 font-13" [(ngModel)]="question"
                  placeholder="FAQ Question"> </textarea>
      </div>
      <span class="red font-13">Answer:</span><br/>
      <ck-editor [(ngModel)]="answer" language="en" [fullPage]="true"></ck-editor>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="update()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<notifier-container></notifier-container>
